export function ucfirst(string: string): string {
	try {
		return string.charAt(0) ? string.charAt(0).toUpperCase() + string.slice(1) : '';
	} catch (error) {
		return ''
	}
}